import { render, staticRenderFns } from "./deductible.vue?vue&type=template&id=fd9709f0"
import script from "./deductible.vue?vue&type=script&lang=js"
export * from "./deductible.vue?vue&type=script&lang=js"
import style0 from "./deductible.vue?vue&type=style&index=0&id=fd9709f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports